module.exports = __webpack_public_path__ + "img/home-section2-0.708ef050.png";